export default __webpack_public_path__ + "static/media/mathematics.b985f461.png";